// A variable to store the selected front wheel image
let selectedFrontWheelImage = null;
let selectedRearWheelImage = null;
let vehicleDetaile = null;
let apiKey = null; // We'll store the token here after fetching once.
let vehicleImageWidthWheel;
let scaleFactorWheel;
let optionalRimDiameter = [];
let optionalRimWidth = [];
let isPaginationEvent = false;

// Cache for API responses keyed by vehicleId
const _apiCache = {};

// Cache for fetched extra wheel search-result pages, keyed by page URL
const _wheelSearchPageCache = {};

// The search results page only renders one page of results at a time
// (results_per_page in the search template), so vehicle-compatible wheels
// (including non-standard/plus sizes) sitting on later search-result pages
// never reach the DOM. This walks the "next page" links of the current
// vehicle wheel search and returns every additional .ezerus-wheel-cards
// element found, so they can be merged in before sorting/filtering.
async function fetchAdditionalWheelCards(startNextUrl) {
  const extraCards = [];
  let nextUrl = startNextUrl;
  let pagesFetched = 0;
  const MAX_EXTRA_PAGES = 15;

  while (nextUrl && pagesFetched < MAX_EXTRA_PAGES) {
    let html = _wheelSearchPageCache[nextUrl];
    if (!html) {
      try {
        const response = await fetch(nextUrl);
        if (!response.ok) break;
        html = await response.text();
        _wheelSearchPageCache[nextUrl] = html;
      } catch (error) {
        console.error(
          "Failed to fetch additional wheel search page:",
          error.message,
        );
        break;
      }
    }

    const parsedDoc = new DOMParser().parseFromString(html, "text/html");
    parsedDoc
      .querySelectorAll(".ezerus-wheel-cards")
      .forEach((card) => extraCards.push(card));

    const nextLink = parsedDoc.querySelector(".pagination .page-number-next");
    nextUrl = nextLink
      ? new URL(nextLink.getAttribute("href"), window.location.origin).toString()
      : null;
    pagesFetched += 1;
  }

  return extraCards;
}

function parseTyreSize(size) {
  if (!size) return null;
  const m = String(size).match(/^(\d+)\/(\d+)R(\d+)$/i);
  if (!m) return null;
  return { section_width: m[1], aspect_ratio: m[2], rim_diameter: m[3] };
}

function buildFitmentRedirectUrl(fitment) {
  if (!fitment || !fitment.front) return null;

  const front = parseTyreSize(fitment.front);
  const rear = parseTyreSize(fitment.rear);
  const parsed = [front, rear].filter(Boolean);
  if (!parsed.length) return null;

  const isStaggered = fitment.rear && fitment.front !== fitment.rear;
  const q = isStaggered
    ? `${fitment.front} ${fitment.rear} Tyres`
    : `${fitment.front} Tyres`;

  const collect = (key) => {
    const set = new Set(parsed.map((s) => s[key]));
    return Array.from(set)
      .sort((a, b) => Number(a) - Number(b))
      .join(",");
  };

  const params = new URLSearchParams(window.location.search);
  params.set("q", q);
  params.set("filter.p.m.custom.section_width", collect("section_width"));
  params.set("filter.p.m.custom.aspect_ratio", collect("aspect_ratio"));
  params.set("filter.p.m.custom.rim_diameter", collect("rim_diameter"));
  params.delete("page");

  const parts = [];
  for (const [k, v] of params.entries()) {
    const enc = String(v).split(",").map(encodeURIComponent).join(",");
    parts.push(`${encodeURIComponent(k)}=${enc}`);
  }

  return `${window.location.pathname}?${parts.join("&")}`;
}

const vehiclebodyImageWheel = document.getElementById("vehicleBodyImage");
const vehicleFrontWheel = document.getElementById("vehicleFrontWheel");
const vehicleRearWheel = document.getElementById("vehicleRearWheel");
const productTabs = document.querySelectorAll(".product-tab");
const tyreProductTabs = document.querySelectorAll(".tyre-product-tab");
const productsContent = document.querySelectorAll(".product-content");
const productTabsContainer = document.getElementById("wheelProductTabs");

// Store references to currently selected checkboxes
let currentlySelectedFrontCheckbox = null;
let currentlySelectedRearCheckbox = null;

function initializeTabListeners() {
  const queryParams = new URLSearchParams(window.location.search);
  const fitmentType = queryParams.get("fitmentType");

  if (fitmentType === "Split") {
    productTabsContainer.style.cssText = "display: flex;";
  }

  // Tyre product tabs — handled by setupTyreFitmentSelector in reapplyWheelVisualization

  // Wheel Product tabs
  document.querySelectorAll(".product-tab").forEach((tab) => {
    tab.addEventListener("click", function () {
      document
        .querySelectorAll(".product-tab")
        .forEach((t) => t.classList.remove("active"));
      document
        .querySelectorAll(".product-content")
        .forEach((c) => c.classList.remove("active"));
      this.classList.add("active");
      const targetContent = document.getElementById(
        this.dataset.tab + "Products",
      );
      if (targetContent) targetContent.classList.add("active");
      resultSlider();
    });
  });

  const disapearButton = document.getElementById("ezerusCustomDisapearButton");
  if (disapearButton) {
    disapearButton.addEventListener("click", function () {
      document.getElementById("ezerusCustomMobileFilter").style.cssText =
        "display: none;";
    });
  }

  const apearMobile = document.getElementById("ezerusFilterMobileButton");
  if (apearMobile) {
    apearMobile.addEventListener("click", function () {
      document.getElementById("ezerusCustomMobileFilter").style.cssText =
        "display: contents;";
    });
  }
}

// Generic GET request with Bearer token
async function fetchWithToken(url) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "x-api-key":
        "1160aaf5feaa534399a169da613a5ace81600ef9d96ad7b173699cdb59a9b17d",
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch data from ${url}: ${response.statusText}`);
  }
  return response.json();
}

// Function to calculate scaleFactorWheel based on window width
function getScaleFactorWheel() {
  if (window.innerWidth > 1024) {
    return 1;
  }
  return vehicleImageWidthWheel / 780;
}

// ResizeObserver to track changes in vehicleBodyImage size
const resizeObserverWheel = new ResizeObserver((entries) => {
  for (let entry of entries) {
    const { width } = entry.contentRect;
    vehicleImageWidthWheel = width;
    scaleFactorWheel = getScaleFactorWheel();
    // Adjust wheel positions here as scaleFactorWheel is updated
    adjustWheelPositions();
  }
});

function adjustWheelPositions() {
  if (!vehicleDetaile || !scaleFactorWheel) return;

  // Adjust front Wheel
  vehicleFrontWheel.style.cssText = `
  position: absolute;
  height: ${vehicleDetaile.WheelImagePositions[0].WheelImageSize.Height * scaleFactorWheel}px;
  width: ${vehicleDetaile.WheelImagePositions[0].WheelImageSize.Width * scaleFactorWheel}px;
  top: ${vehicleDetaile.WheelImagePositions[0].FrontWheelImageOrigin.Top * scaleFactorWheel}px;
  left: ${vehicleDetaile.WheelImagePositions[0].FrontWheelImageOrigin.Left * scaleFactorWheel}px;
 `;

  // Adjust rear Wheel
  vehicleRearWheel.style.cssText = `
  position: absolute;
  height: ${vehicleDetaile.WheelImagePositions[0].WheelImageSize.Height * scaleFactorWheel}px;
  width: ${vehicleDetaile.WheelImagePositions[0].WheelImageSize.Width * scaleFactorWheel}px;
  top: ${vehicleDetaile.WheelImagePositions[0].RearWheelImageOrigin.Top * scaleFactorWheel}px;
  left: ${vehicleDetaile.WheelImagePositions[0].RearWheelImageOrigin.Left * scaleFactorWheel}px;
 `;
}

function uncheckAllFrontWheelCheckboxes() {
  const frontCheckboxes = document.querySelectorAll(
    '.view-on-car-checkbox[id*="front-wheel"]',
  );
  const sameSizeCheckboxes = document.querySelectorAll(
    '.view-on-car-checkbox[id*="same-size-wheel"]',
  );

  if (frontCheckboxes.length > 0) {
    frontCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Only clear the wheel image if we're actually removing the selection
    if (selectedFrontWheelImage) {
      vehicleFrontWheel.innerHTML = "";
      selectedFrontWheelImage = null;
      currentlySelectedFrontCheckbox = null;
    }
  } else if (sameSizeCheckboxes.length > 0) {
    sameSizeCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Only clear the wheel image if we're actually removing the selection
    if (selectedFrontWheelImage) {
      vehicleFrontWheel.innerHTML = "";
      selectedFrontWheelImage = null;
      currentlySelectedFrontCheckbox = null;
    }
  }
}

function uncheckAllRearWheelCheckboxes() {
  const rearCheckboxes = document.querySelectorAll(
    '.view-on-car-checkbox[id*="rear-wheel"]',
  );
  rearCheckboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  // Only clear the wheel image if we're actually removing the selection
  if (selectedRearWheelImage) {
    vehicleRearWheel.innerHTML = "";
    selectedRearWheelImage = null;
    currentlySelectedRearCheckbox = null;
  }
}

// Function to set front wheel image and sync checkboxes
function setFrontWheelImage(imageSrc, activeCheckbox) {
  // First, uncheck all other front wheel checkboxes
  uncheckAllFrontWheelCheckboxes();

  // Set the new active checkbox
  if (activeCheckbox) {
    activeCheckbox.checked = true;
    currentlySelectedFrontCheckbox = activeCheckbox;
  }

  // Save the front wheel image source and display it
  selectedFrontWheelImage = imageSrc;
  vehicleFrontWheel.innerHTML = "";
  const frontWheelImage = document.createElement("img");
  frontWheelImage.src = selectedFrontWheelImage;
  scaleFactorWheel = getScaleFactorWheel();
  vehicleFrontWheel.appendChild(frontWheelImage);
}

// Function to set rear wheel image and sync checkboxes
function setRearWheelImage(imageSrc, activeCheckbox) {
  // First, uncheck all other rear wheel checkboxes
  uncheckAllRearWheelCheckboxes();

  // Set the new active checkbox
  if (activeCheckbox) {
    activeCheckbox.checked = true;
    currentlySelectedRearCheckbox = activeCheckbox;
  }

  // Save the rear wheel image source and display it
  selectedRearWheelImage = imageSrc;
  vehicleRearWheel.innerHTML = "";
  const rearWheelImage = document.createElement("img");
  rearWheelImage.src = selectedRearWheelImage;
  scaleFactorWheel = getScaleFactorWheel();
  vehicleRearWheel.appendChild(rearWheelImage);
}

// Function to clear front wheel
function clearFrontWheel() {
  uncheckAllFrontWheelCheckboxes();
}

// Function to clear rear wheel
function clearRearWheel() {
  uncheckAllRearWheelCheckboxes();
}

document.addEventListener("change", function (event) {
  const checkbox = event.target;

  if (checkbox.classList.contains("view-on-car-checkbox")) {
    const isFront = checkbox.id.includes("front-wheel");
    const isRear = checkbox.id.includes("rear-wheel");
    const isSame = checkbox.id.includes("same-size-wheel");

    const productItem = checkbox.closest(".ezerus-wheel-cards");
    const wheelImg = productItem?.querySelector(".WheelWebOnCar");
    if (!wheelImg) return;

    if (isSame) {
      if (checkbox.checked) {
        setFrontWheelImage(wheelImg.src, checkbox);
        setRearWheelImage(wheelImg.src, checkbox);
      } else {
        clearFrontWheel();
        clearRearWheel();
      }
    } else {
      if (isFront) {
        if (checkbox.checked) {
          setFrontWheelImage(wheelImg.src, checkbox);
        } else {
          clearFrontWheel();
        }
      }
      if (isRear) {
        if (checkbox.checked) {
          setRearWheelImage(wheelImg.src, checkbox);
        } else {
          clearRearWheel();
        }
      }
    }
  }
});

async function reapplyWheelVisualization() {
  const BASE_URL = "https://vehicle-logic-vqxgw.ondigitalocean.app/";
  const enableAlternativeWheelFitments =
    document.getElementById("product-grid")?.dataset.enableAlternativeWheelFitments !== "false";
  const frontTyresContainer = document.getElementById("frontTyresContainer");
  const rearTyresContainer = document.getElementById("rearTyresContainer");
  const allTyresContainer = document.getElementById("allTyresContainer");
  const queryParams = new URLSearchParams(window.location.search);
  const standardFrontRimWidth = queryParams.get("frontWidths");
  const standardRearRimWidth = queryParams.get("rearWidths");
  const standardFrontRimDiameter = queryParams.get("frontRimDiameter");
  const standardRearRimDiameter = queryParams.get("rearRimDiameter");
  const vehicleId = queryParams.get("vehicleId");
  const standardFrontTyreSize = queryParams.get("standardFrontTyreSize");
  const standardRearTyreSize = queryParams.get("standardRearTyreSize");
  const standardTyreSize = queryParams.get("standardTyreSize");
  const mixedTyreSize = queryParams.get("mixedTyreSize");
  // Full factory search URL persisted by shop-tyres-wheels.js when the user
  // first arrived from a rego/vehicle lookup. Used to restore the original
  // URL (including all filter params) when switching back to Factory fitment.
  let factoryTyreUrl = null;
  let factoryTyreQuery = null;
  if (vehicleId) {
    try {
      factoryTyreUrl = localStorage.getItem('factory_tyre_url_' + vehicleId);
      if (factoryTyreUrl) {
        try {
          factoryTyreQuery = new URL(factoryTyreUrl, window.location.origin).searchParams.get('q');
        } catch (_) {
          factoryTyreQuery = null;
        }
      }
    } catch (e) {
      factoryTyreUrl = null;
      factoryTyreQuery = null;
    }
  }
  const allTyreItems = Array.from(
    document.querySelectorAll(".ezerus-tyre-cards"),
  );
  const tyresTab = document.querySelector(".outter-product-tab-container");

  let frontIds = new Set();
  let rearIds = new Set();
  let optionalSize = new Set();
  let optionalFrontTyreSize = new Set();
  let optionalRearTyreSize = new Set();
  let allOptionalTyreSize = new Set();
  let standardFrontIds = new Set();
  let standardRearIds = new Set();

  // Clear global arrays to prevent duplicates on repeated calls
  optionalRimDiameter = [];
  optionalRimWidth = [];

  let frontTyreIds = [];
  let rearTyreIds = [];

  // Use cached API data when available
  const cacheKey = vehicleId || "";
  if (!_apiCache[cacheKey]) {
    _apiCache[cacheKey] = {};
  }

  try {
    if (!_apiCache[cacheKey].tyreSizesData) {
      const tyreSizesUrl = `${BASE_URL}api/vehicles/${vehicleId}/tyres/pattern`;
      _apiCache[cacheKey].tyreSizesData = await fetchWithToken(tyreSizesUrl);
    }
    const tyreSizesData = _apiCache[cacheKey].tyreSizesData;

    tyreSizesData.Items.forEach((item) => {
      item.TyreFitments.forEach((fitment) => {
        if (fitment?.FrontTyre?.Id) frontTyreIds.push(fitment?.FrontTyre?.Id);
        if (fitment?.RearTyre?.Id) rearTyreIds.push(fitment?.RearTyre?.Id);
      });
    });
  } catch (error) {
    console.error("Tyre IDs not found!", error.message);
  }

  const uniqueFrontTyreIds = [...new Set(frontTyreIds)];
  const uniqueRearTyreIds = [...new Set(rearTyreIds)];

  const frontTyreIdsString = uniqueFrontTyreIds.join(",");
  const rearTyreIdsString = uniqueRearTyreIds.join(",");

  try {
    if (!_apiCache[cacheKey].wheelIdData) {
      const wheelIdUrl = `${BASE_URL}api/vehicles/${vehicleId}/wheels`;
      _apiCache[cacheKey].wheelIdData = await fetchWithToken(wheelIdUrl);
    }
    const wheelIdData = _apiCache[cacheKey].wheelIdData;

    wheelIdData.Items.forEach((item) => {
      item.WheelFitments.forEach((fitment) => {
        const frontId = fitment.FrontWheel?.Id + "W";
        const rearId = fitment.RearWheel?.Id + "W";
        const frontSize = `${fitment?.FrontWheel?.Size?.RimDiameter}" x ${fitment?.FrontWheel?.Size?.RimWidth}"`;
        const rearSize = `${fitment?.RearWheel?.Size?.RimDiameter}" x ${fitment?.RearWheel?.Size?.RimWidth}"`;
        const frontTyreSize = fitment?.FrontTyreSize?.Description;
        const rearTyreSize = fitment?.RearTyreSize?.Description;

        if (
          fitment?.FrontWheel?.Size?.RimDiameter.toString() ===
            standardFrontRimDiameter &&
          fitment?.FrontWheel?.Size?.RimWidth.toString() ===
            standardFrontRimWidth
        ) {
          standardFrontIds.add(fitment?.FrontWheel?.Id);
        }

        if (
          fitment?.RearWheel?.Size?.RimDiameter.toString() ===
            standardRearRimDiameter &&
          fitment?.RearWheel?.Size?.RimWidth.toString() === standardRearRimWidth
        ) {
          standardRearIds.add(fitment?.RearWheel?.Id);
        }

        if (frontId) frontIds.add(frontId);
        if (rearId) rearIds.add(rearId);
        if (frontSize) optionalSize.add(frontSize);
        if (rearSize) optionalSize.add(rearSize);
        if (frontTyreSize) optionalFrontTyreSize.add(frontTyreSize);
        if (rearTyreSize) optionalRearTyreSize.add(rearTyreSize);
        if (frontTyreSize) allOptionalTyreSize.add(frontTyreSize);
        if (rearTyreSize) allOptionalTyreSize.add(rearTyreSize);
      });
    });

    wheelIdData.ValidFilterValues.RimDiameters.map((diameter) => {
      optionalRimDiameter.push(diameter);
    });

    wheelIdData.ValidFilterValues.RimWidths.map((width) => {
      optionalRimWidth.push(width);
    });
  } catch (error) {
    console.error("Wheel IDs not found!", error.message);
  }

  // Convert sets to arrays
  const frontIdsArray = Array.from(frontIds);
  const rearIdsArray = Array.from(rearIds);
  const optionalSizeArray = Array.from(optionalSize);
  const optionalFrontTyreSizeArray = Array.from(optionalFrontTyreSize);
  const optionalRearTyreSizeArray = Array.from(optionalRearTyreSize);
  const allOptionalTyreSizeArray = Array.from(allOptionalTyreSize);
  const standardFrontIdsArray = Array.from(standardFrontIds);
  const standardRearIdsArray = Array.from(standardRearIds);

  const frontStandardWheelString = standardFrontIdsArray.join(",");
  const rearStandardWheelString = standardRearIdsArray.join(",");

  const filteredOptionalSizes = optionalSizeArray.filter(
    (size) =>
      size !== `${standardFrontRimDiameter}" x ${standardFrontRimWidth}"` &&
      size !== `${standardRearRimDiameter}" x ${standardRearRimWidth}"`,
  );

  const frontWheelString = frontIdsArray.join(",");
  const rearWheelString = rearIdsArray.join(",");
  const optionalSizeLabel =
    filteredOptionalSizes.length > 0
      ? filteredOptionalSizes.join(" - ")
      : "Various Sizes";

  const optionalFrontTyreSizeLabel = optionalFrontTyreSizeArray
    ?.filter(
      (size) => size !== standardFrontTyreSize && size !== standardTyreSize,
    )
    .join(" - ");
  const optionalRearTyreSizeLabel = optionalRearTyreSizeArray
    ?.filter(
      (size) => size !== standardRearTyreSize && size !== standardTyreSize,
    )
    .join(" - ");
  const allOptionalTyreSizeString = allOptionalTyreSizeArray
    ?.filter((size) => size !== standardTyreSize)
    .join(" - ");

  // Convert front/rear widths into arrays if comma-separated
  const frontWheelArr = standardFrontRimWidth
    ? standardFrontRimWidth.split(",")
    : [];
  const rearWheelArr = standardRearRimWidth
    ? standardRearRimWidth.split(",")
    : [];
  const sameSizeWheel =
    JSON.stringify(frontWheelArr) === JSON.stringify(rearWheelArr)
      ? frontWheelArr
      : [];

  // Check if front and rear tyres are the same
  const sameSizeTyre = standardFrontTyreSize === standardRearTyreSize;
  const optionalFrontTyreSizes = optionalFrontTyreSizeArray.filter(
    (size) =>
      size && size !== standardFrontTyreSize && size !== standardTyreSize,
  );
  const optionalRearTyreSizes = optionalRearTyreSizeArray.filter(
    (size) =>
      size && size !== standardRearTyreSize && size !== standardTyreSize,
  );
  const selectedOptionalFrontTyreSize = optionalFrontTyreSizes[0] || "";
  const selectedOptionalRearTyreSize =
    optionalRearTyreSizes[0] || selectedOptionalFrontTyreSize;
  const tyreFitments = {
    standard: {
      front: standardFrontTyreSize || standardTyreSize,
      rear: standardRearTyreSize || standardTyreSize,
      frontIds: frontTyreIdsString,
      rearIds: rearTyreIdsString,
    },
    optional: {
      front: selectedOptionalFrontTyreSize,
      rear: selectedOptionalRearTyreSize,
      frontIds: frontTyreIdsString,
      rearIds: rearTyreIdsString,
    },
  };

  let activeTyreTab =
    document.querySelector(".tyre-product-tab.active")?.dataset.tab || "all";

  function createTyreTitledContainer(parentContainer, title) {
    const container = document.createElement("div");

    const innerContainer = document.createElement("div");
    innerContainer.classList =
      "ezerus-custom-product-grid-split product-grid grid";

    container.appendChild(innerContainer);
    parentContainer.appendChild(container);

    return innerContainer;
  }

  function hasTyreFitmentSizes(fitment) {
    return Boolean(fitment.front && fitment.rear);
  }

  function getActiveTyreFitmentType() {
    const checkedInput = document.querySelector(
      'input[name="tyre_fitment_size"]:checked:not(:disabled)',
    );

    return checkedInput?.value || "standard";
  }

  function getTyreFitmentLabel(fitment, tab) {
    const isStaggered = fitment.front !== fitment.rear;

    if (tab === "front") {
      return `<span class="ez-fitment-size-line"><strong>Front:</strong> ${fitment.front}</span>`;
    }

    if (tab === "rear") {
      return `<span class="ez-fitment-size-line"><strong>Rear:</strong> ${fitment.rear}</span>`;
    }

    if (isStaggered) {
      return `<span class="ez-fitment-staggered"><span class="ez-fitment-size-line"><strong>Front:</strong> ${fitment.front}</span><span class="ez-fitment-size-line"><strong>Rear:</strong> ${fitment.rear}</span></span>`;
    }

    return `${fitment.front}`;
  }

  function updateTyreFitmentLabels() {
    Object.entries(tyreFitments).forEach(([type, fitment]) => {
      const label = document.querySelector(
        `[data-tyre-fitment-label="${type}"]`,
      );

      if (!label) return;

      if (!hasTyreFitmentSizes(fitment)) {
        if (type === "optional") {
          label.textContent =
            "No optional tyre size is available for your vehicle.";
        }
        return;
      }

      label.innerHTML = getTyreFitmentLabel(fitment, activeTyreTab);
    });
  }

  function updateTyreFitmentInputs() {
    Object.entries(tyreFitments).forEach(([type, fitment]) => {
      const input = document.querySelector(
        `input[name="tyre_fitment_size"][value="${type}"]`,
      );

      if (!input) return;

      input.disabled = !hasTyreFitmentSizes(fitment);
    });
  }

  function updateTyreFitmentSelectedText() {
    const activeFitmentType = getActiveTyreFitmentType();

    document
      .querySelectorAll("[data-tyre-fitment-selected]")
      .forEach((marker) => {
        const option = marker.closest("[data-tyre-fitment-option]");
        marker.hidden =
          !option || option.dataset.tyreFitmentOption !== activeFitmentType;
      });
  }

  function getTyreItemsForFitment(fitmentType, tab) {
    const fitment = tyreFitments[fitmentType];

    if (!hasTyreFitmentSizes(fitment)) {
      return [];
    }

    // For standard fitment, only include items matching the exact standard sizes
    const standardFront = tyreFitments.standard.front;
    const standardRear = tyreFitments.standard.rear;

    return allTyreItems.filter((item) => {
      const tyreSize = item.getAttribute("data-tyresize");

      if (fitmentType === "standard") {
        // Only show factory fitment sizes
        if (tab === "front") {
          return tyreSize === standardFront;
        }
        if (tab === "rear") {
          return tyreSize === standardRear;
        }
        return tyreSize === standardFront || tyreSize === standardRear;
      }

      // Optional fitment
      if (tab === "front") {
        return tyreSize === fitment.front;
      }

      if (tab === "rear") {
        return tyreSize === fitment.rear;
      }

      return tyreSize === fitment.front || tyreSize === fitment.rear;
    });
  }

  function setTyreItemPositionLabel(tyreItem, fitment, tab) {
    const frontRearLabel = tyreItem.querySelector(".front-rear-label");

    if (!frontRearLabel) return;

    const tyreSize = tyreItem.getAttribute("data-tyresize");

    if (tab === "front") {
      frontRearLabel.textContent = "Front";
    } else if (tab === "rear") {
      frontRearLabel.textContent = "Rear";
    } else if (
      fitment.front === fitment.rear ||
      (tyreSize === fitment.front && tyreSize === fitment.rear)
    ) {
      frontRearLabel.textContent = "Front & Rear";
    } else if (tyreSize === fitment.front) {
      frontRearLabel.textContent = "Front";
    } else if (tyreSize === fitment.rear) {
      frontRearLabel.textContent = "Rear";
    }

    frontRearLabel.style.display = "block";
  }

  function renderSelectedTyreFitment() {
    if (!allTyresContainer) return;

    const activeFitmentType = getActiveTyreFitmentType();
    const fitment = tyreFitments[activeFitmentType];
    const selectedTyreItems = getTyreItemsForFitment(
      activeFitmentType,
      activeTyreTab,
    );

    allTyresContainer.innerHTML = "";

    if (!hasTyreFitmentSizes(fitment)) {
      const message = document.createElement("div");
      message.className = "ez-tyre-no-results";
      message.innerHTML =
        "<p>No optional tyre size is available for your vehicle.</p>";
      allTyresContainer.appendChild(message);
      return;
    }

    if (selectedTyreItems.length === 0) {
      const tabLabel = activeTyreTab === "all" ? "" : ` (${activeTyreTab})`;
      const sizeLabel =
        activeFitmentType === "standard" ? "factory" : "optional";
      const message = document.createElement("div");
      message.className = "ez-tyre-no-results";
      message.innerHTML = `<p>No matching tyres found for the selected ${sizeLabel} fitment size${tabLabel}.</p>`;
      allTyresContainer.appendChild(message);
      return;
    }

    const tyreGrid = createTyreTitledContainer(allTyresContainer, "");

    selectedTyreItems.forEach((tyreItem) => {
      const clonedItem = tyreItem.cloneNode(true);
      setTyreItemPositionLabel(clonedItem, fitment, activeTyreTab);

      const wrapper = document.createElement("div");
      wrapper.className = "ez--slide";
      wrapper.appendChild(clonedItem);
      tyreGrid.appendChild(wrapper);
    });

    resultSlider();
  }

  function syncTyreFitmentRadioFromUrl() {
    const currentQ = new URLSearchParams(window.location.search).get("q") || "";
    const buildExpectedQ = (fitment) => {
      if (!fitment || !fitment.front) return null;
      if (!fitment.rear || fitment.front === fitment.rear) {
        return `${fitment.front} Tyres`;
      }
      return `${fitment.front} ${fitment.rear} Tyres`;
    };

    const expectedOptional = buildExpectedQ(tyreFitments.optional);
    const expectedStandard = buildExpectedQ(tyreFitments.standard);

    let matchedType = null;
    if (factoryTyreQuery && currentQ === factoryTyreQuery) {
      matchedType = "standard";
    } else if (expectedOptional && currentQ === expectedOptional) {
      matchedType = "optional";
    } else if (expectedStandard && currentQ === expectedStandard) {
      matchedType = "standard";
    }

    if (!matchedType) return;

    document
      .querySelectorAll('input[name="tyre_fitment_size"]')
      .forEach((input) => {
        input.checked = input.value === matchedType;
      });
  }

  function setupTyreFitmentSelector() {
    updateTyreFitmentInputs();
    syncTyreFitmentRadioFromUrl();
    updateTyreFitmentLabels();
    updateTyreFitmentSelectedText();

    document
      .querySelectorAll('input[name="tyre_fitment_size"]')
      .forEach((input) => {
        if (input.dataset.fitmentBound === "true") return;
        input.dataset.fitmentBound = "true";
        input.addEventListener("change", () => {
          const fitmentType = input.value;
          const fitment = tyreFitments[fitmentType];

          if (!hasTyreFitmentSizes(fitment)) {
            updateTyreFitmentSelectedText();
            renderSelectedTyreFitment();
            return;
          }

          // When switching back to Factory fitment, restore the original
          // factory search URL saved in localStorage instead of rebuilding a
          // tyre-size-based query.
          if (fitmentType === "standard" && factoryTyreUrl) {
            window.location.href = factoryTyreUrl;
            return;
          }

          const newUrl = buildFitmentRedirectUrl(fitment);
          if (newUrl) {
            window.location.href = newUrl;
          }
        });
      });

    document.querySelectorAll(".tyre-product-tab").forEach((tab) => {
      if (tab.dataset.tyrTabBound === "true") return;
      tab.dataset.tyrTabBound = "true";
      tab.addEventListener("click", () => {
        document
          .querySelectorAll(".tyre-product-tab")
          .forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
        activeTyreTab = tab.dataset.tab || "all";
        updateTyreFitmentLabels();
        renderSelectedTyreFitment();
      });
    });
  }

  // Clear containers
  if (frontTyresContainer) frontTyresContainer.innerHTML = "";
  if (rearTyresContainer) rearTyresContainer.innerHTML = "";
  if (allTyresContainer) allTyresContainer.innerHTML = "";

  // Define tyre sort priority functions
  function getFrontTyreSortPriority(tyreItem) {
    const tyreSize = tyreItem.getAttribute("data-tyresize");
    let priority = 0;

    if (tyreSize === standardFrontTyreSize) {
      priority = 1000;
    } else if (optionalFrontTyreSizeArray.includes(tyreSize)) {
      priority = 500;
    } else {
      priority = 100;
    }

    return priority;
  }

  function getRearTyreSortPriority(tyreItem) {
    const tyreSize = tyreItem.getAttribute("data-tyresize");
    let priority = 0;

    if (tyreSize === standardRearTyreSize) {
      priority = 1000;
    } else if (optionalRearTyreSizeArray.includes(tyreSize)) {
      priority = 500;
    } else {
      priority = 100;
    }

    return priority;
  }

  function getAllTyresSortPriority(tyreItem) {
    const tyreSize = tyreItem.getAttribute("data-tyresize");
    const isSpecial = tyreItem.getAttribute("data-special") === "1";
    let priority = 0;

    if (
      tyreSize === standardFrontTyreSize ||
      tyreSize === standardRearTyreSize
    ) {
      priority = 1000;
    } else if (
      optionalFrontTyreSizeArray.includes(tyreSize) ||
      optionalRearTyreSizeArray.includes(tyreSize)
    ) {
      priority = 500;
    } else {
      priority = 100;
    }

    if (isSpecial && !isPaginationEvent) {
      priority += 2000;
    }

    return priority;
  }

  // Sort tyres function
  function sortTyreItems(items, priorityFunction) {
    return items.sort((a, b) => {
      const priorityA = priorityFunction(a);
      const priorityB = priorityFunction(b);

      if (priorityA !== priorityB) {
        return priorityB - priorityA;
      }

      // Additional sorting by tyre size if needed
      const sizeA = a.getAttribute("data-tyresize") || "";
      const sizeB = b.getAttribute("data-tyresize") || "";
      return sizeA.localeCompare(sizeB);
    });
  }

  // Filter tyre items for each container
  const frontTyreItems = allTyreItems.filter((item) => {
    const tyreSize = item.getAttribute("data-tyresize");
    return (
      tyreSize === standardFrontTyreSize ||
      optionalFrontTyreSizeArray.includes(tyreSize)
    );
  });

  const rearTyreItems = allTyreItems.filter((item) => {
    const tyreSize = item.getAttribute("data-tyresize");
    return (
      tyreSize === standardRearTyreSize ||
      optionalRearTyreSizeArray.includes(tyreSize)
    );
  });

  // Sort tyre items
  const sortedFrontTyreItems = sortTyreItems(
    [...frontTyreItems],
    getFrontTyreSortPriority,
  );
  const sortedRearTyreItems = sortTyreItems(
    [...rearTyreItems],
    getRearTyreSortPriority,
  );
  const sortedAllTyreItems = sortTyreItems(
    [...allTyreItems],
    getAllTyresSortPriority,
  );

  setupTyreFitmentSelector();
  renderSelectedTyreFitment();

  // Get all product items (wheels) rendered on the current search-results page
  const initialProductItems = Array.from(
    document.querySelectorAll(".ezerus-wheel-cards"),
  );

  // Merge in any vehicle-compatible wheels sitting on later search-result
  // pages (e.g. non-standard/plus sizes) so they can be sorted alongside the
  // standard sizes instead of being hidden by pagination. Skipped on manual
  // pagination clicks, where the current page's own results should stand.
  let allProductItems = initialProductItems;
  if (vehicleId && !isPaginationEvent) {
    const nextPageLink = document.querySelector(
      ".pagination .page-number-next",
    );
    if (nextPageLink) {
      try {
        const nextUrl = new URL(
          nextPageLink.getAttribute("href"),
          window.location.origin,
        ).toString();
        const extraCards = await fetchAdditionalWheelCards(nextUrl);
        const seenIds = new Set(
          initialProductItems.map(
            (item) =>
              item.getAttribute("data-product-id") ||
              item.getAttribute("data-ids"),
          ),
        );
        const dedupedExtraCards = extraCards.filter((card) => {
          const id =
            card.getAttribute("data-product-id") ||
            card.getAttribute("data-ids");
          if (!id || seenIds.has(id)) return false;
          seenIds.add(id);
          return true;
        });
        allProductItems = [...initialProductItems, ...dedupedExtraCards];
      } catch (error) {
        console.error(
          "Failed to merge additional wheel search pages:",
          error.message,
        );
      }
    }
  }

  // Define sort priority functions for wheels (unchanged)
  function getFrontSortPriority(productItem) {
    const rimWidth = parseFloat(productItem.getAttribute("data-rimwidth"));
    const rimDiameter = parseFloat(
      productItem.getAttribute("data-rimdiameter"),
    );
    const wheelId = productItem.getAttribute("data-ids");

    let priority = 0;
    const matchesStandardFront =
      standardFrontRimWidth &&
      standardFrontRimWidth.split(",").includes(rimWidth.toString()) &&
      standardFrontRimDiameter &&
      parseFloat(standardFrontRimDiameter) === rimDiameter;

    if (matchesStandardFront) {
      priority = 1000;
    } else if (
      optionalRimDiameter.includes(rimDiameter) &&
      optionalRimWidth.includes(rimWidth)
    ) {
      priority = 500;
    } else {
      priority = 100;
    }

    if (frontWheelString.includes(wheelId)) {
      priority += 50;
    }

    return priority;
  }

  function getRearSortPriority(productItem) {
    const rimWidth = parseFloat(productItem.getAttribute("data-rimwidth"));
    const rimDiameter = parseFloat(
      productItem.getAttribute("data-rimdiameter"),
    );
    const wheelId = productItem.getAttribute("data-ids");

    let priority = 0;
    const matchesStandardRear =
      standardRearRimWidth &&
      standardRearRimWidth.split(",").includes(rimWidth.toString()) &&
      standardRearRimDiameter &&
      parseFloat(standardRearRimDiameter) === rimDiameter;

    if (matchesStandardRear) {
      priority = 1000;
    } else if (
      optionalRimDiameter.includes(rimDiameter) &&
      optionalRimWidth.includes(rimWidth)
    ) {
      priority = 500;
    } else {
      priority = 100;
    }

    if (rearWheelString.includes(wheelId)) {
      priority += 50;
    }

    return priority;
  }

  function getAllWheelsSortPriority(productItem) {
    const rimWidth = parseFloat(productItem.getAttribute("data-rimwidth"));
    const rimDiameter = parseFloat(
      productItem.getAttribute("data-rimdiameter"),
    );
    const wheelId = productItem.getAttribute("data-ids");

    let priority = 0;
    const matchesStandardFront =
      standardFrontRimWidth &&
      standardFrontRimWidth.split(",").includes(rimWidth.toString()) &&
      standardFrontRimDiameter &&
      parseFloat(standardFrontRimDiameter) === rimDiameter;
    const matchesStandardRear =
      standardRearRimWidth &&
      standardRearRimWidth.split(",").includes(rimWidth.toString()) &&
      standardRearRimDiameter &&
      parseFloat(standardRearRimDiameter) === rimDiameter;

    if (matchesStandardFront || matchesStandardRear) {
      priority = 1000;
    } else if (
      optionalRimDiameter.includes(rimDiameter) &&
      optionalRimWidth.includes(rimWidth)
    ) {
      priority = 500;
    } else {
      priority = 100;
    }

    if (
      frontWheelString.includes(wheelId) &&
      rearWheelString.includes(wheelId)
    ) {
      priority += 50;
    } else if (
      frontWheelString.includes(wheelId) ||
      rearWheelString.includes(wheelId)
    ) {
      priority += 25;
    }

    return priority;
  }

  // Sort items function for wheels (unchanged)
  function sortItems(items, priorityFunction) {
    return items.sort((a, b) => {
      const priorityA = priorityFunction(a);
      const priorityB = priorityFunction(b);

      if (priorityA !== priorityB) {
        return priorityB - priorityA;
      }

      const diameterA = parseFloat(a.getAttribute("data-rimdiameter"));
      const diameterB = parseFloat(b.getAttribute("data-rimdiameter"));

      if (diameterA !== diameterB) {
        return diameterA - diameterB;
      }

      const widthA = parseFloat(a.getAttribute("data-rimwidth"));
      const widthB = parseFloat(b.getAttribute("data-rimwidth"));

      return widthA - widthB;
    });
  }

  // Apply the setting after merging pages, including cached results. A priority
  // of 1000 or more identifies a factory rim diameter and width for that axle.
  if (vehicleId && !enableAlternativeWheelFitments) {
    allProductItems = allProductItems.filter(
      (item) => getAllWheelsSortPriority(item) >= 1000,
    );
  }

  // Filter wheel items for each container
  const frontItems = allProductItems.filter((item) => {
    const wheelId = item.getAttribute("data-ids");
    return frontWheelString.includes(wheelId) &&
      (!vehicleId || enableAlternativeWheelFitments || getFrontSortPriority(item) >= 1000);
  });

  const rearItems = allProductItems.filter((item) => {
    const wheelId = item.getAttribute("data-ids");
    return rearWheelString.includes(wheelId) &&
      (!vehicleId || enableAlternativeWheelFitments || getRearSortPriority(item) >= 1000);
  });

  // Sort wheel items
  const sortedFrontItems = sortItems([...frontItems], getFrontSortPriority);
  const sortedRearItems = sortItems([...rearItems], getRearSortPriority);
  const sortedAllItems = sortItems(
    [...allProductItems],
    getAllWheelsSortPriority,
  );

  // Get wheel container references
  const frontContainer = document.getElementById("frontContainer");
  const rearContainer = document.getElementById("rearContainer");
  const allWheelContainer = document.getElementById("allWheelContainer");

  // Function to create titled sub-divs for wheels
  function createTitledContainer(parentContainer, title) {
    const container = document.createElement("div");

    const innerContainer = document.createElement("div");
    innerContainer.classList =
      "ezerus-custom-product-grid-split product-grid grid";

    const titleElement = document.createElement("h5");
    titleElement.textContent = title;
    titleElement.style.margin = "1.5rem 0";

    container.appendChild(titleElement);
    container.appendChild(innerContainer);
    parentContainer.appendChild(container);

    return innerContainer;
  }

  // Clear wheel containers
  if (frontContainer) frontContainer.innerHTML = "";
  if (rearContainer) rearContainer.innerHTML = "";
  if (allWheelContainer) allWheelContainer.innerHTML = "";

  // Process front wheel items (existing logic continues...)
  if (frontContainer) {
    const frontStandardContainer = createTitledContainer(
      frontContainer,
      `Standard Wheel Sizes for Your Vehicle - ${standardFrontRimDiameter}" x ${standardFrontRimWidth}" `,
    );

    sortedFrontItems.forEach((productItem) => {
      const wheelId = productItem.getAttribute("data-ids");
      const frontRearLabel = productItem.querySelector(
        `.front-rear-label-${wheelId}`,
      );

      if (frontRearLabel) {
        if (
          frontWheelString.includes(wheelId) &&
          rearWheelString.includes(wheelId)
        ) {
          frontRearLabel.textContent = "Front & Rear";
          frontRearLabel.style.display = "block";
        } else if (frontWheelString.includes(wheelId)) {
          frontRearLabel.textContent = "Front";
          frontRearLabel.style.display = "block";
        }
      }

      if (sameSizeWheel.length <= 0) {
        let innerDiv = productItem.childNodes[1];
        if (innerDiv && !innerDiv.querySelector(".checkbox-container")) {
          const frontCheckbox = document.createElement("input");
          frontCheckbox.type = "checkbox";
          frontCheckbox.classList.add("view-on-car-checkbox");
          if (
            frontWheelString.includes(wheelId) &&
            rearWheelString.includes(wheelId)
          ) {
            frontCheckbox.setAttribute(
              "id",
              `same-size-wheel-${Date.now()}-${Math.random()}`,
            );
          } else {
            frontCheckbox.setAttribute(
              "id",
              `front-wheel-${Date.now()}-${Math.random()}`,
            );
          }

          const frontCheckboxLabel = document.createElement("label");
          frontCheckboxLabel.textContent = "Visualise";
          frontCheckboxLabel.setAttribute("for", frontCheckbox.id);

          const frontCheckboxContainer = document.createElement("div");
          frontCheckboxContainer.classList.add("checkbox-container");
          frontCheckboxContainer.appendChild(frontCheckboxLabel);
          frontCheckboxContainer.appendChild(frontCheckbox);

          innerDiv.insertBefore(
            frontCheckboxContainer,
            innerDiv.children[2] || null,
          );

          frontCheckbox.addEventListener("change", () => {
            const frontWheelImg = productItem.querySelector(".WheelWebOnCar");
            if (frontWheelImg) {
              if (
                frontWheelString.includes(wheelId) &&
                rearWheelString.includes(wheelId)
              ) {
                if (frontCheckbox.checked) {
                  setFrontWheelImage(frontWheelImg.src, frontCheckbox);
                  setRearWheelImage(frontWheelImg.src, frontCheckbox);
                } else {
                  clearFrontWheel();
                  clearRearWheel();
                }
              } else if (frontCheckbox.checked) {
                setFrontWheelImage(frontWheelImg.src, frontCheckbox);
              } else {
                clearFrontWheel();
              }
            }
          });
        }

        const clonedItem = productItem.cloneNode(true);
        // Append to Standard or Optional based on priority
        if (frontWheelString.includes(wheelId)) {
          const wrapper = document.createElement("div");
          wrapper.className = "ez--slide";
          wrapper.appendChild(clonedItem);
          frontStandardContainer.appendChild(wrapper);
        }
      }
    });
  }

  // Process rear wheel items
  if (rearContainer) {
    const rearStandardContainer = createTitledContainer(
      rearContainer,
      `Standard Wheel Sizes for Your Vehicle - ${standardRearRimDiameter}" x ${standardRearRimWidth}" `,
    );

    sortedRearItems.forEach((productItem) => {
      const wheelId = productItem.getAttribute("data-ids");
      const frontRearLabel = productItem.querySelector(
        `.front-rear-label-${wheelId}`,
      );

      if (frontRearLabel) {
        if (
          frontWheelString.includes(wheelId) &&
          rearWheelString.includes(wheelId)
        ) {
          frontRearLabel.textContent = "Front & Rear";
          frontRearLabel.style.display = "block";
        } else if (rearWheelString.includes(wheelId)) {
          frontRearLabel.textContent = "Rear";
          frontRearLabel.style.display = "block";
        }
      }

      if (sameSizeWheel.length <= 0) {
        let innerDiv = productItem.childNodes[1];
        if (innerDiv && !innerDiv.querySelector(".checkbox-container")) {
          const rearCheckbox = document.createElement("input");
          rearCheckbox.type = "checkbox";
          rearCheckbox.classList.add("view-on-car-checkbox");
          rearCheckbox.setAttribute(
            "id",
            `rear-wheel-${Date.now()}-${Math.random()}`,
          );

          const rearCheckboxLabel = document.createElement("label");
          rearCheckboxLabel.textContent = "Visualise";
          rearCheckboxLabel.setAttribute("for", rearCheckbox.id);

          const rearCheckboxContainer = document.createElement("div");
          rearCheckboxContainer.classList.add("checkbox-container");
          rearCheckboxContainer.appendChild(rearCheckboxLabel);
          rearCheckboxContainer.appendChild(rearCheckbox);

          innerDiv.insertBefore(
            rearCheckboxContainer,
            innerDiv.children[2] || null,
          );

          rearCheckbox.addEventListener("change", () => {
            const rearWheelImg = productItem.querySelector(".WheelWebOnCar");
            if (rearWheelImg) {
              if (rearCheckbox.checked) {
                setRearWheelImage(rearWheelImg.src, rearCheckbox);
              } else {
                clearRearWheel();
              }
            }
          });
        }

        const clonedItem = productItem.cloneNode(true);
        // Append to Standard or Optional based on priority
        if (rearWheelString.includes(wheelId)) {
          const wrapper = document.createElement("div");
          wrapper.className = "ez--slide";
          wrapper.appendChild(clonedItem);
          rearStandardContainer.appendChild(wrapper);
        }
      }
    });

    if (rearStandardContainer.children.length <= 0) {
      rearContainer.style.display = "none";
    }
  }

  // Process same size wheels or all wheel items
  if (allWheelContainer) {
    let sizeInTitle = "";
    if (
      `${standardFrontRimDiameter}" x ${standardFrontRimWidth}"` ===
      `${standardRearRimDiameter}" x ${standardRearRimWidth}"`
    ) {
      sizeInTitle = `${standardFrontRimDiameter}" x ${standardFrontRimWidth}"`;
    } else {
      sizeInTitle = `${standardFrontRimDiameter}" x ${standardFrontRimWidth}" - ${standardRearRimDiameter}" x ${standardRearRimWidth}"`;
    }
    const allStandardContainer = createTitledContainer(
      allWheelContainer,
      `Standard Wheel Sizes for Your Vehicle - ${sizeInTitle} `,
    );

    if (sameSizeWheel.length > 0) {
      const sameSizeItems = allProductItems.filter((item) => {
        const wheelId = item.getAttribute("data-ids");
        return (
          frontWheelString.includes(wheelId) ||
          rearWheelString.includes(wheelId)
        );
      });

      const sortedSameSizeItems = sortItems(
        [...sameSizeItems],
        getAllWheelsSortPriority,
      );

      sortedSameSizeItems.forEach((productItem) => {
        const wheelId = productItem.getAttribute("data-ids");

        let innerDiv = productItem.childNodes[1];
        if (innerDiv && !innerDiv.querySelector(".checkbox-container")) {
          const sameSizeCheckbox = document.createElement("input");
          sameSizeCheckbox.type = "checkbox";
          sameSizeCheckbox.classList.add("view-on-car-checkbox");
          sameSizeCheckbox.setAttribute(
            "id",
            `same-size-wheel-${Date.now()}-${Math.random()}`,
          );

          const sameSizeCheckboxLabel = document.createElement("label");
          sameSizeCheckboxLabel.textContent = "Visualise";
          sameSizeCheckboxLabel.setAttribute("for", sameSizeCheckbox.id);

          const sameSizeCheckboxContainer = document.createElement("div");
          sameSizeCheckboxContainer.classList.add("checkbox-container");
          sameSizeCheckboxContainer.appendChild(sameSizeCheckboxLabel);
          sameSizeCheckboxContainer.appendChild(sameSizeCheckbox);

          innerDiv.insertBefore(
            sameSizeCheckboxContainer,
            innerDiv.children[2] || null,
          );

          sameSizeCheckbox.addEventListener("change", () => {
            const sameSizeWheelImg =
              productItem.querySelector(".WheelWebOnCar");
            if (sameSizeWheelImg) {
              if (sameSizeCheckbox.checked) {
                setFrontWheelImage(sameSizeWheelImg.src, sameSizeCheckbox);
                setRearWheelImage(sameSizeWheelImg.src, sameSizeCheckbox);
              } else {
                clearFrontWheel();
                clearRearWheel();
              }
            }
          });
        }

        // Append to Standard or Optional based on priority
        const wrapper = document.createElement("div");
        wrapper.className = "ez--slide";
        wrapper.appendChild(productItem);
        allStandardContainer.appendChild(wrapper);
      });
    } else {
      sortedAllItems.forEach((productItem) => {
        const wheelId = productItem.getAttribute("data-ids");
        const frontRearLabel = productItem.querySelector(
          `.front-rear-label-${wheelId}`,
        );

        if (frontRearLabel) {
          if (
            frontWheelString.includes(wheelId) &&
            rearWheelString.includes(wheelId)
          ) {
            frontRearLabel.textContent = "Front & Rear";
            frontRearLabel.style.display = "block";
          } else if (frontWheelString.includes(wheelId)) {
            frontRearLabel.textContent = "Front";
            frontRearLabel.style.display = "block";
          } else if (rearWheelString.includes(wheelId)) {
            frontRearLabel.textContent = "Rear";
            frontRearLabel.style.display = "block";
          }
        }

        let innerDiv = productItem.childNodes[1];
        if (innerDiv && !innerDiv.querySelector(".checkbox-container")) {
          const mixedSizeCheckbox = document.createElement("input");
          mixedSizeCheckbox.type = "checkbox";
          mixedSizeCheckbox.classList.add("view-on-car-checkbox");
          mixedSizeCheckbox.setAttribute(
            "id",
            `same-size-wheel-${Date.now()}-${Math.random()}`,
          );

          const mixedSizeCheckboxLabel = document.createElement("label");
          mixedSizeCheckboxLabel.textContent = "Visualise";
          mixedSizeCheckboxLabel.setAttribute("for", mixedSizeCheckbox.id);

          const mixedSizeCheckboxContainer = document.createElement("div");
          mixedSizeCheckboxContainer.classList.add("checkbox-container");
          mixedSizeCheckboxContainer.appendChild(mixedSizeCheckboxLabel);
          mixedSizeCheckboxContainer.appendChild(mixedSizeCheckbox);

          innerDiv.insertBefore(
            mixedSizeCheckboxContainer,
            innerDiv.children[2] || null,
          );

          mixedSizeCheckbox.addEventListener("change", () => {
            const mixedSizeWheelImg =
              productItem.querySelector(".WheelWebOnCar");
            if (mixedSizeWheelImg) {
              if (mixedSizeCheckbox.checked) {
                setFrontWheelImage(mixedSizeWheelImg.src, mixedSizeCheckbox);
                setRearWheelImage(mixedSizeWheelImg.src, mixedSizeCheckbox);
              } else {
                clearFrontWheel();
                clearRearWheel();
              }
            }
          });
        }

        // Append to Standard or Optional based on priority
        const wrapper = document.createElement("div");
        wrapper.className = "ez--slide";
        wrapper.appendChild(productItem);
        allStandardContainer.appendChild(wrapper);
      });
    }
    if (allStandardContainer.children.length <= 0) {
      allWheelContainer.style.display = "none";
    }
  }

  // Single resultSlider call for all wheel containers
  resultSlider();

  // Restore selected wheel images
  if (selectedFrontWheelImage && vehicleFrontWheel) {
    const frontWheelImage = document.createElement("img");
    frontWheelImage.src = selectedFrontWheelImage;
    vehicleFrontWheel.innerHTML = "";
    vehicleFrontWheel.appendChild(frontWheelImage);

    document.querySelectorAll(".view-on-car-checkbox").forEach((checkbox) => {
      if (
        checkbox.id.includes("front-wheel") ||
        checkbox.id.includes("same-size-wheel")
      ) {
        const productItem = checkbox.closest(".ezerus-wheel-cards");
        if (productItem) {
          const img = productItem.querySelector(".WheelWebOnCar");
          if (img && img.src === selectedFrontWheelImage) {
            checkbox.checked = true;
            currentlySelectedFrontCheckbox = checkbox;
          }
        }
      }
    });
  }

  if (selectedRearWheelImage && vehicleRearWheel) {
    const rearWheelImage = document.createElement("img");
    rearWheelImage.src = selectedRearWheelImage;
    vehicleRearWheel.innerHTML = "";
    vehicleRearWheel.appendChild(rearWheelImage);

    document.querySelectorAll(".view-on-car-checkbox").forEach((checkbox) => {
      if (
        checkbox.id.includes("rear-wheel") ||
        checkbox.id.includes("same-size-wheel")
      ) {
        const productItem = checkbox.closest(".ezerus-wheel-cards");
        if (productItem) {
          const img = productItem.querySelector(".WheelWebOnCar");
          if (img && img.src === selectedRearWheelImage) {
            checkbox.checked = true;
            currentlySelectedRearCheckbox = checkbox;
          }
        }
      }
    });
  }

  // Auto-select default wheels if none selected
  const firstSameSizeCheckbox = document.querySelector(
    '.view-on-car-checkbox[id*="same-size-wheel"]',
  );
  if (
    firstSameSizeCheckbox &&
    !selectedFrontWheelImage &&
    !selectedRearWheelImage
  ) {
    const productItem = firstSameSizeCheckbox.closest(".ezerus-wheel-cards");
    if (productItem) {
      const wheelImg = productItem.querySelector(".WheelWebOnCar");
      if (wheelImg) {
        setFrontWheelImage(wheelImg.src, firstSameSizeCheckbox);
        setRearWheelImage(wheelImg.src, firstSameSizeCheckbox);
      }
    }
  } else {
    if (!selectedFrontWheelImage) {
      const firstFrontCheckbox = document.querySelector(
        '.view-on-car-checkbox[id*="front-wheel"]',
      );
      if (firstFrontCheckbox) {
        const productItem = firstFrontCheckbox.closest(".ezerus-wheel-cards");
        if (productItem) {
          const frontWheelImg = productItem.querySelector(".WheelWebOnCar");
          if (frontWheelImg) {
            setFrontWheelImage(frontWheelImg.src, firstFrontCheckbox);
          }
        }
      }
    }

    if (!selectedRearWheelImage) {
      const firstRearCheckbox = document.querySelector(
        '.view-on-car-checkbox[id*="rear-wheel"]',
      );
      if (firstRearCheckbox) {
        const productItem = firstRearCheckbox.closest(".ezerus-wheel-cards");
        if (productItem) {
          const rearWheelImg = productItem.querySelector(".WheelWebOnCar");
          if (rearWheelImg) {
            setRearWheelImage(rearWheelImg.src, firstRearCheckbox);
          }
        }
      }
    }
  }
}

// Start observing the vehicleBodyImage
if (vehiclebodyImageWheel) {
  resizeObserverWheel.observe(vehiclebodyImageWheel);
}

function initializeTyreFitmentInfoButtons() {
  document.querySelectorAll(".ez-fitment-info-button").forEach((button) => {
    if (button.dataset.fitmentInfoBound === "true") return;

    const panelId = button.getAttribute("aria-describedby");
    const panel = panelId ? document.getElementById(panelId) : null;

    if (!panel) return;

    button.dataset.fitmentInfoBound = "true";

    const togglePanel = () => {
      const isOpen = button.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        panel.hidden = true;
        button.setAttribute("aria-expanded", "false");
      } else {
        // Close any other open panels first
        document
          .querySelectorAll(".ez-fitment-info-button")
          .forEach((otherBtn) => {
            if (otherBtn !== button) {
              const otherPanelId = otherBtn.getAttribute("aria-describedby");
              const otherPanel = otherPanelId
                ? document.getElementById(otherPanelId)
                : null;
              if (otherPanel) otherPanel.hidden = true;
              otherBtn.setAttribute("aria-expanded", "false");
            }
          });
        panel.hidden = false;
        button.setAttribute("aria-expanded", "true");
      }
    };

    button.addEventListener("click", togglePanel);

    // Close panel when clicking outside
    document.addEventListener("click", (e) => {
      if (!button.contains(e.target) && !panel.contains(e.target)) {
        panel.hidden = true;
        button.setAttribute("aria-expanded", "false");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", async function () {
  const BASE_URL = "https://vehicle-logic-vqxgw.ondigitalocean.app/";
  const queryParams = new URLSearchParams(window.location.search);
  const vehicleId = queryParams.get("vehicleId");
  const vehicleName = queryParams.get("vehicleName");
  const vehicleYear = queryParams.get("vehicleYear");
  const vehicleQuery = queryParams.get("q");
  const urlRimDiameter = Number(
    queryParams.get("filter.p.m.custom.rim_diameter"),
  );
  const urlSectionWidth = Number(
    queryParams.get("filter.p.m.custom.section_width"),
  );
  const urlAspectRatio = Number(
    queryParams.get("filter.p.m.custom.aspect_ratio"),
  );

  const searchResultTitle = document.querySelectorAll(".searchResultTitle");
  if (vehicleName?.length > 0) {
    searchResultTitle.forEach((el) => {
      el.textContent = `for ${vehicleName} - ${vehicleYear}`;
    });
  } else if (vehicleQuery?.length > 0) {
    if (urlSectionWidth && urlSectionWidth > 100) {
      if (urlAspectRatio === 0) {
        if (urlRimDiameter === 0) {
          searchResultTitle.forEach((el) => {
            el.textContent = `${urlSectionWidth}R`;
          });
        } else {
          searchResultTitle.forEach((el) => {
            el.textContent = `${urlSectionWidth}R${urlRimDiameter}`;
          });
        }
      } else {
        searchResultTitle.forEach((el) => {
          el.textContent = `${urlSectionWidth}/${urlAspectRatio}R${urlRimDiameter}`;
        });
      }
    } else {
      if (urlAspectRatio === 0) {
        if (urlRimDiameter === 0) {
          searchResultTitle.forEach((el) => {
            el.textContent = `${urlSectionWidth}x`;
          });
        } else {
          searchResultTitle.forEach((el) => {
            el.textContent = `${urlSectionWidth}xR${urlRimDiameter}`;
          });
        }
      } else {
        searchResultTitle.forEach((el) => {
          el.textContent = `${urlSectionWidth}x${urlAspectRatio}R${urlRimDiameter}`;
        });
      }
    }
  }

  if (vehicleQuery && vehicleQuery.includes("Wheels")) {
    const wheelResultPage = vehicleQuery.split(" ").some((q) => q === "Wheels");

    const url = `${BASE_URL}api/vehicles/${vehicleId}/wheelsonvehicle`;
    if (vehicleId && wheelResultPage) {
      const data = await fetchWithToken(url);
      vehicleDetaile = data;
      adjustWheelPositions(); // Call initially after vehicleDetaile is fetched
    }
  }
  initializeTabListeners();
  initializeTyreFitmentInfoButtons();
  const NewUrl = new URL(window.location);
  if (NewUrl.pathname.includes("/search")) {
    // if (!vehicleId) {
    //   const selectTyreSize = document.getElementById("selectTyreSize");
    //   if (selectTyreSize) selectTyreSize.style.display = "none";
    // }
    reapplyWheelVisualization();
  }
  resultSlider();
});

const form = document.getElementById("FacetsFilterForm");
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const inputWhitelist = [".facet", ".collection-actions-wrapper"];

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.debouncedOnSubmitReduced = debounce(
      (event) => {
        this.onSubmitHandler(event);
      },
      250,
      true,
    );

    this.addEventListener("input", (event) => {
      if (
        !inputWhitelist.some((selector) => !!event.target.closest(selector))
      ) {
        return false;
      }

      if (event.target.closest("price-range")) {
        this.debouncedOnSubmit(event);
      } else {
        this.debouncedOnSubmitReduced(event);
      }
    });
  }

  static async performSearch(searchTerm, resultsContainer) {
    if (!searchTerm) return;

    // Show loading spinner
    resultsContainer.innerHTML = '<div class="loading-spinner"></div>';

    try {
      const response = await fetch(
        `/search?q=${encodeURIComponent(searchTerm)}&type=product`,
      );
      const data = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const productGrid = doc.querySelector("#product-grid");

      if (productGrid) {
        resultsContainer.innerHTML = "";
        resultsContainer.appendChild(productGrid);
        resultSlider();
      } else {
        resultsContainer.innerHTML = "<p>No results found.</p>";
      }
    } catch (error) {
      console.error("Error performing search:", error);
      resultsContainer.innerHTML =
        "<p>An error occurred while loading results.</p>";
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) {
        return;
      }
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true, appendResults) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const productGridContainer = document.getElementById(
      "ProductGridContainer",
    );

    if (productGridContainer) {
      productGridContainer
        .querySelector(".collection")
        .classList.add("loading");
    }

    if (countContainer) {
      countContainer.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, appendResults);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }

    if (!searchParams.includes("page")) {
      publish(PUB_SUB_EVENTS.collectionFilters, {
        filters: deserializeSearchParams(searchParams),
      });
    }
  }

  static renderSectionFromFetch(url, event, appendResults) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderCollectionActions(html);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, appendResults);
        resultSlider();
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderCollectionActions(html);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html, appendResults) {
    const container = document.getElementById("ProductGridContainer");
    const parsedDom = new DOMParser().parseFromString(html, "text/html");
    const parsedContainer = parsedDom.getElementById("ProductGridContainer");

    // Check if both container and parsedContainer exist
    if (!container) {
      console.error("ProductGridContainer not found in current document");
      return;
    }

    if (!parsedContainer) {
      console.error("ProductGridContainer not found in parsed HTML");
      const emp_parsedProductGrid = document.getElementById("product-grid");
      const parsedProductGrid = parsedDom.querySelector(
        ".template-search-empty",
      );

      if (container) {
        container.querySelector(".collection").classList.remove("loading");
      }
      emp_parsedProductGrid.innerHTML = parsedProductGrid.innerHTML;
      document.querySelectorAll("ajax-paginate").forEach((el) => el.remove());
      return;
    }

    if (appendResults) {
      const parsedProductGrid = parsedDom.getElementById("product-grid");
      const currentProductGrid = document.getElementById("product-grid");

      if (parsedProductGrid && currentProductGrid) {
        parsedProductGrid.prepend(...[...currentProductGrid.childNodes]);
      }
    }

    container.innerHTML = parsedContainer.innerHTML;
    initializeTabListeners();
    initializeTyreFitmentInfoButtons();
    // Reapply wheel visualization functionality after content is updated
    const NewUrl = new URL(window.location);
    if (NewUrl.pathname.includes("/search")) {
      reapplyWheelVisualization();
      isPaginationEvent = false;
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount")?.innerHTML;
    const container = document.getElementById("ProductCount");

    if (!container) return;

    container.innerHTML = count;
    container.classList.remove("loading");
  }

  static renderCollectionActions(html) {
    const container = document.getElementById("CollectionActions");
    const parsedDom = new DOMParser().parseFromString(html, "text/html");

    if (!container) return;

    container.classList =
      parsedDom.getElementById("CollectionActions").classList;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter",
    );

    const isPriceFilter = (element) => {
      return !!element.querySelector("price-range");
    };

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => {
        if (isPriceFilter(element)) {
          return !matchesIndex(element);
        }
        return true;
      },
    );

    facetsToRender.forEach((element) => {
      const oldElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );
      element
        .querySelector(".facet-toggle")
        .setAttribute(
          "aria-expanded",
          oldElement
            .querySelector(".facet-toggle")
            .getAttribute("aria-expanded"),
        );
      element
        .querySelector("collapsible-expandable")
        .setAttribute(
          "expanded",
          oldElement
            .querySelector("collapsible-expandable")
            .getAttribute("expanded"),
        );
      oldElement.innerHTML = element.innerHTML;
    });

    // Special handling for the price range (don't replace the entire element to keep input focus).
    const priceFilter = Array.from(facetDetailsElements).find(isPriceFilter);
    if (priceFilter) {
      const priceHeader = document.querySelector(".js-price-range-header");
      const newPriceHeader = priceFilter.querySelector(
        ".js-price-range-header",
      );
      priceHeader.innerHTML = newPriceHeader.innerHTML;
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".collection-actions-filters"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;

      const domElement = document.querySelector(selector);
      if (domElement) {
        // Add this check to prevent null reference
        domElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static toggleActiveFacets(disable = true) {
    const activeFacetsContainer = document.querySelector(
      ".collection-actions-filters",
    );

    if (!activeFacetsContainer) return;

    if (disable) {
      activeFacetsContainer.classList.add("disabled");
    } else {
      activeFacetsContainer.classList.remove("disabled");

      // Also ensure the container is visible if there are active facets
      const activeFacets = activeFacetsContainer.querySelectorAll(
        ".collection-actions-filter",
      );
      if (activeFacets.length > 0) {
        activeFacetsContainer.style.display = "block";
      } else {
        activeFacetsContainer.style.display = "none";
      }
    }
  }

  static updateURLHash(searchParams, replace) {
    if (replace) {
      history.replaceState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    } else {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    }
  }

  static getSections() {
    const productGrid = document.getElementById("product-grid");

    if (!productGrid) return [];

    return [{ section: productGrid.dataset.id }];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Get current URL parameters
    const currentParams = new URLSearchParams(window.location.search);

    // Always preserve sort_by parameter
    const sortBy = document.querySelector('[name="sort_by"]');
    if (sortBy && sortBy.value) {
      currentParams.set("sort_by", sortBy.value);
    }

    // Get the input that triggered this event
    const triggerInput = event.target;

    if (triggerInput && triggerInput.type === "checkbox") {
      // Handle checkbox input
      const name = triggerInput.name;
      const value = triggerInput.value;
      const isChecked = triggerInput.checked;

      // Get existing values for this filter
      let existingValues = currentParams.get(name)
        ? currentParams.get(name).split(",")
        : [];

      if (isChecked) {
        // Add the value if it's not already there
        if (!existingValues.includes(value)) {
          existingValues.push(value);
        }
      } else {
        // Remove the value if unchecked
        existingValues = existingValues.filter((v) => v !== value);
      }

      // Update the parameter
      if (existingValues.length > 0) {
        currentParams.set(name, existingValues.join(","));
      } else {
        currentParams.delete(name);
      }
    } else {
      // For non-checkbox inputs, we need to handle them differently
      // Get all form data to handle other input types
      const formData = new FormData(
        document.getElementById("FacetsFilterForm"),
      );

      // Update non-checkbox parameters
      for (const [key, value] of formData.entries()) {
        // Skip if it's a checkbox (handled separately)
        const input = document.querySelector(`[name="${key}"]`);
        if (input && input.type === "checkbox") continue;

        if (value && value.trim() !== "") {
          currentParams.set(key, value);
        } else {
          currentParams.delete(key);
        }
      }

      // Also ensure all currently checked checkboxes are in the params
      // This is important for maintaining state after non-checkbox changes
      const checkboxGroups = {};
      document
        .querySelectorAll('#FacetsFilterForm input[type="checkbox"]:checked')
        .forEach((checkbox) => {
          const name = checkbox.name;
          const value = checkbox.value;

          if (!checkboxGroups[name]) {
            checkboxGroups[name] = [];
          }
          checkboxGroups[name].push(value);
        });

      // Update checkbox parameters based on current state
      for (const [name, values] of Object.entries(checkboxGroups)) {
        if (values.length > 0) {
          currentParams.set(name, values.join(","));
        }
      }
    }

    const paramsArray = [];
    for (const [key, value] of currentParams.entries()) {
      // split by comma (Shopify multi-value separator)
      const parts = value.split(",");

      // encode each part individually
      const encodedParts = parts.map((v) => encodeURIComponent(v));

      // rejoin with literal commas
      const finalValue = encodedParts.join(",");

      paramsArray.push(`${encodeURIComponent(key)}=${finalValue}`);
    }

    const searchParams = paramsArray.join("&");

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") === -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }

  onAjaxPagination(event) {
    event.preventDefault();

    isPaginationEvent = true;
    // Resolve clicked anchor (works even if handler is on a wrapper)
    const anchor = event.currentTarget.closest
      ? event.currentTarget.closest("a[href]")
      : null;

    // Figure out requested page from the clicked link (safe parse)
    let requestedPage = null;
    if (anchor) {
      try {
        const linkUrl = new URL(
          anchor.getAttribute("href"),
          window.location.origin,
        );
        requestedPage = linkUrl.searchParams.get("page");
      } catch {
        /* ignore */
      }
    }

    // —— Build a new query string while preserving original encodings ——
    // rawSearch includes the leading '?', so strip it
    const rawSearch = window.location.search.startsWith("?")
      ? window.location.search.slice(1)
      : window.location.search;

    const pairs = rawSearch ? rawSearch.split("&") : [];

    // Map of existing keys -> indices (to quickly find 'page')
    const keyIndex = new Map();
    for (let i = 0; i < pairs.length; i += 1) {
      const eq = pairs[i].indexOf("=");
      const rawKey = eq === -1 ? pairs[i] : pairs[i].slice(0, eq);
      // Don’t decode; preserve as-is
      if (!keyIndex.has(rawKey)) keyIndex.set(rawKey, i);
    }

    // We only modify the *encoded* key "page"
    const encodedPageKey = "page";

    if (requestedPage && requestedPage.trim() !== "") {
      // encode only the value we add
      const encodedVal = encodeURIComponent(
        String(parseInt(requestedPage, 10) || 1),
      );
      if (keyIndex.has(encodedPageKey)) {
        const idx = keyIndex.get(encodedPageKey);
        // Replace existing page=...
        pairs[idx] = `${encodedPageKey}=${encodedVal}`;
      } else {
        // Append new page=... (keeps all other params intact)
        pairs.push(`${encodedPageKey}=${encodedVal}`);
      }
    } else {
      // Remove page parameter entirely (back to page 1)
      if (keyIndex.has(encodedPageKey)) {
        pairs.splice(keyIndex.get(encodedPageKey), 1);
      }
    }

    // String for downstream code (no leading '?')
    const preservedSearchParams = pairs.filter(Boolean).join("&");

    // Render the new page
    FacetFiltersForm.renderPage(preservedSearchParams, event, true);

    // Optionally reflect in address bar without re-encoding the whole string
    const newUrl = `${window.location.pathname}${preservedSearchParams ? `?${preservedSearchParams}` : ""}${window.location.hash}`;
    if (
      newUrl !==
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    ) {
      history.replaceState(null, "", newUrl);
    }

    // Scroll
    const productGridContainer = document.getElementById(
      "ProductGridContainer",
    );
    const fallbackContainer = document.querySelector(".search-result-title");
    const scrollTarget = productGridContainer || fallbackContainer;
    if (scrollTarget && typeof scrollToElement === "function") {
      scrollToElement(scrollTarget, -150);
    }

    // Publish a clean page number
    const pageNum = Math.max(1, parseInt(requestedPage, 10) || 1);
    publish(PUB_SUB_EVENTS.pageChange, { page: pageNum });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

// ------------------------
//  Additional Custom Elements
// ------------------------

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class AjaxPaginate extends HTMLElement {
  constructor() {
    super();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    const buttons = this.querySelectorAll("a");

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        form.onAjaxPagination(event);
      });
    });
  }
}

customElements.define("ajax-paginate", AjaxPaginate);

function scrollToElement(element, offset) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  window.scrollTo({
    top: absoluteElementTop + offset,
    behavior: "smooth",
  });
}

function resultSlider() {
  const queryParams = new URLSearchParams(window.location.search);
  const wheelResult = queryParams.get("q");

  if (wheelResult.includes("Wheels")) {
    let gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer.classList.contains("ez-search-slider")) {
      var sliderElems = document.querySelectorAll(
        ".ez-search-slider .ezerus-custom-product-grid-split",
      );
      sliderElems.forEach(function (elem) {
        elem.style.visibility = "hidden";
        function showSlider() {
          elem.style.visibility = "visible";
          if (document.querySelector(".ezerus-bysize-container")) {
            const loadingElement = document.querySelector(".sr_loading");
            if (loadingElement) {
              loadingElement.remove();
            }
          }
        }
        if (!elem.classList.contains("flickity-enabled")) {
          let flkty = new Flickity(elem, {
            autoPlay: false,
            cellAlign: "left",
            groupCells: true,
            contain: true,
            resize: true,
            draggable: true,
            dragThreshold: 1,
            prevNextButtons: true,
            fade: false,
            cellSelector: ".ez--slide",
            initialIndex: 0,
            pageDots: true,
            wrapAround: false,
            accessibility: false,
            watchCSS: false,
          });

          // Store the instance for later
          elem.flickityInstance = flkty;
          setTimeout(() => showSlider(elem), 10);
        } else if (elem.flickityInstance) {
          // If already initialized, just refresh layout
          elem.flickityInstance.resize();
          elem.flickityInstance.reloadCells();
          setTimeout(() => showSlider(elem), 50);
        }
      });
    } else if (gridContainer.classList.contains("ez-search-grid")) {
      var gridElem = document.querySelectorAll(
        ".ez-search-grid .ezerus-custom-product-grid",
      );
      setTimeout(() => showSlider(elem), 10);
    }

    function showSlider(elem) {
      elem.style.visibility = "visible";
      if (document.querySelector(".ezerus-bysize-container")) {
        const loadingElement = document.querySelector(".sr_loading");
        if (loadingElement) {
          loadingElement.remove();
        }
      }
    }
  }
}

/**
 * Accepts a query string from faceted filtering and returns a
 * deserialized object.
 *
 * @param {string} queryString The query string.
 * @returns {{}}
 */
const deserializeSearchParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};

  for (const [key, value] of params.entries()) {
    if (result[key]) {
      result[key] = `${result[key]},${value}`;
    } else if (value) {
      result[key] = value;
    }
  }

  return result;
};
